// client/src/components/Admin/DataRequestsInfoModal.js
import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";

// Material UI Components
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Close from "@material-ui/icons/Close";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";

// Styles
import stylesModal from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.js";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

const stylesCard = {
  cardTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    textAlign: "center",
  },
  infoLabel: {
    fontWeight: "600",
    fontSize: "16px",
    color: "#3C4858",
    marginBottom: "8px",
    textAlign: "center",
  },
  infoContent: {
    fontSize: "15px",
    color: "#555555",
    marginBottom: "20px",
    textAlign: "center",
    lineHeight: "1.5",
  },
};

const useStylesModal = makeStyles(stylesModal);
const useStylesCard = makeStyles(stylesCard);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const DataRequestsInfoModal = ({ open, onClose, formData }) => {
  const classesModal = useStylesModal();
  const classesCard = useStylesCard();
  const classes = { ...classesModal, ...classesCard };

  return (
    <Dialog
      classes={{
        root: classes.center + " " + classes.modalRoot,
        paper: classes.modal,
      }}
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-labelledby="data-request-info-modal-title"
      aria-describedby="data-request-info-modal-description"
    >
      <DialogTitle
        id="data-request-info-modal-title"
        disableTypography
        className={classes.modalHeader}
      >
        <Button
          justIcon
          className={classes.modalCloseButton}
          key="close"
          aria-label="Close"
          color="transparent"
          onClick={onClose}
        >
          <Close className={classes.modalClose} />
        </Button>
        <span className={classes.modalTitle}>{formData.name}</span>
      </DialogTitle>
      <DialogContent
        id="data-request-info-modal-description"
        className={classes.modalBody}
      >
        <div className={classes.modalBody}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <div className={classes.infoLabel}>Email</div>
              <div className={classes.infoContent}>{formData.email}</div>
            </GridItem>
          </GridContainer>

          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <div className={classes.infoLabel}>Institution</div>
              <div className={classes.infoContent}>{formData.institution}</div>
            </GridItem>
          </GridContainer>

          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <div className={classes.infoLabel}>Description</div>
              <div className={classes.infoContent}>{formData.description}</div>
            </GridItem>
          </GridContainer>

          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <div className={classes.infoLabel}>Type</div>
              <div className={classes.infoContent}>{formData.type}</div>
            </GridItem>
          </GridContainer>
        </div>
      </DialogContent>
      <DialogActions
        className={classes.modalFooter + " " + classes.modalFooterCenter}
      >
        <Button onClick={onClose} color="rose" round>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DataRequestsInfoModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  formData: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    institution: PropTypes.string,
    description: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
};

export default DataRequestsInfoModal;
